import React from "react";
import { MapPin, Phone } from "lucide-react";
import { COMPANY } from "../data/tarifas";

export default function Header() {
  return (
    <header className="sticky top-0 z-30 bg-[#fdf9f8]/90 backdrop-blur border-b border-[#efe4e6]">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a
          href="https://veysa.es/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-baseline gap-2.5 group"
          aria-label="Ir a la web de VEYSA"
        >
          <span className="font-display text-2xl font-800 tracking-tight text-[#631024] transition-colors group-hover:text-[#7a1530]" style={{ fontWeight: 800 }}>
            {COMPANY.name}
          </span>
          <span className="hidden sm:inline text-[11px] font-semibold tracking-[0.22em] text-[#9b8388] uppercase">
            {COMPANY.tagline}
          </span>
        </a>

        <div className="flex items-center gap-3 sm:gap-5">
          <div className="hidden sm:flex items-center gap-1.5 text-sm text-[#6d5a5e]">
            <MapPin className="w-4 h-4 text-[#631024]" />
            <span>{COMPANY.location}</span>
          </div>
          <a
            href="tel:+34695292062"
            className="inline-flex items-center gap-2 rounded-full bg-[#631024] text-white text-sm font-semibold px-4 py-2 transition-all duration-200 hover:bg-[#7a1530] hover:shadow-lg hover:shadow-[#631024]/20 active:scale-[0.98]"
          >
            <Phone className="w-4 h-4" />
            Reservar
          </a>
        </div>
      </div>
    </header>
  );
}
